import type { PropsWithChildren, ReactNode } from "react";

import { useBackgroundSync } from "@/features/demo/hooks/useBackgroundSync";

export const BackgroundSyncProvider = (
  { children }: PropsWithChildren,
): ReactNode => {
  // Initialize background sync for demo mode
  useBackgroundSync();

  return <>{children}</>;
};
